<template>
  <div class="custom-filter-module">
    <div class="custom-filter-module_search">
      <el-autocomplete
        ref="templateFilter"
        v-model="templateKey"
        clearable
        placeholder="搜索模板或文件夹"
        class="tpl-popper"
        popper-class="kye-popper-auto"
        value-key="name"
        :trigger-on-focus="false"
        :fetch-suggestions="filterTemplate"
        @select="selectTemplate">
        <i slot="prefix" class="layout layout-search"></i>
      </el-autocomplete>
      <div class="module_search-icon" @click="addFolder">
        <i class="layout layout-custom-file-add"></i>
      </div>
    </div>
    <el-scrollbar>
      <el-checkbox
        style="padding-left: 6px;"
        v-show="!showBatchRemove && templateList.length > 0"
        v-model="checkedMap.value"
        @change="checkAllChange"
        :indeterminate="checkedMap.indeterminate">全选
      </el-checkbox>
      <el-tree
        ref="customModuleTree"
        v-if="templateList.length"
        :data="templateList"
        node-key="id"
        :props="defaultProps"
        class="tpl-list"
        @node-expand="nodeExpand"
        @node-collapse="nodeCollapse"
        @node-drag-end="handleDragEnd"
        :default-expanded-keys="defaultExpandedKeys"
        draggable
        :allow-drop="allowDrop"
        >
        <div class="tpl" slot-scope="{ data }">
          <div class="tpl-name">
            <div @click.stop>
              <el-checkbox  v-show="!showBatchRemove" v-model="data._checked" @change="checkChange(data)" style="margin-right: 8px;"></el-checkbox>
            </div>
            <img class="tpl-list-icon" :src="data.folderFlag === 1 ? require('./assets/custom-folder.svg'): require('./assets/custom-file.svg')" />
              <div
              class="name"
              :class="nameClass(data)"
              @click="loadTemplate(data)">
              {{data.name}}
            </div>
          </div>
          <el-dropdown v-show="showMoreBtn(data)" @command="(val) => handleMore(val, data)" trigger="click">
            <div class="module_more" @click.stop>
              <img src="./assets/custom-file-more.svg" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="updateTemplate">
                <i class="layout layout-bianji custom-filter-icon-size"></i>
                重命名
              </el-dropdown-item>
              <el-dropdown-item command="removeTemplate">
                <i class="layout layout-shanchu custom-filter-icon-size"></i>
                删除
              </el-dropdown-item>
              <el-dropdown-item v-if="data.folderFlag !== 1" command="moveTemplate">
                <i class="layout layout-zhuanfa custom-filter-icon-size"></i>
                移动到
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-tree>
      <div class="kye-custom-filter-dialog__no-data" v-else>
        <img class="kye-custom-filter-dialog__no-data-img" src="./assets/custom-filter-no-data.png"/>
        <span class="kye-custom-filter-dialog__no-data-text">暂无数据</span>
      </div>
    </el-scrollbar>
    <folder-move-dialog ref="folderMove" :model="model" :folderItem="folderItem" @change="moveFolder" :list="templateList"></folder-move-dialog>
  </div>
</template>
<script>
  import folderMoveDialog from './folder-move-dialog'

  const EMPTY_LIST = []
  const FILE_NAME = 'GLOBAL_SEARCH_GENERIC_FILE'

  export default {
    components: { folderMoveDialog },
    props: {
      module: Object,
      templateList: {
        type: Array,
        default: () => []
      },
      showBatchRemove: {
        type: Boolean
      },
      model: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        templateKey: '',
        defaultProps: {
          children: 'templateList',
          label: 'name'
        },
        folderItem: {},
        selectItem: {
          name: ''
        },
        defaultExpandedKeys: [], // 默认展开节点
        checkedMap: {
          value: false,
          indeterminate: false
        },
        selectedItemId: ''
      }
    },
    watch: {
      // 删除模版更新全选状态
      templateList () {
        this.checkedMap.value = false
        this.checkedMap.indeterminate = false
      }
    },
    created () {
      this.getExpandedKeys()
    },
    methods: {
      resetTemplate () {
        this.selectedItemId = ''
      },
      filterTemplate (val, cb) {
        if (!this.templateList.length || !val || val.length < 2) {
          cb(EMPTY_LIST)
          return
        }
        // 平铺数据
        let templateList = []
        this.templateList.map(item => {
          templateList.push(item)
          if (item.templateList && item.templateList.length) {
            item.templateList.map(newItem => {
              templateList.push(newItem)
            })
          }
        })
        let arr = templateList.filter(v => v.name && v.name.includes(val))
        cb(arr)
        // 自动选择第一行
        this.$nextTick(_ => {
          arr.length && this.$refs['templateFilter'].highlight && this.$refs['templateFilter'].highlight(0)
        })
      },
      loadTemplate(item) {
        // 设置当前选中的文件夹或模版id
        this.selectedItemId = item.id
        this.$emit('loadTemplate', item)
      },
      selectTemplate (val) {
        if (val) {
          this.loadTemplate(val)
          this.templateKey = ''
          // 搜索打开当前树
          const selectItem = this.$refs.customModuleTree.getNode(val.id)
          if (selectItem && selectItem.parent) {
            selectItem.parent.expanded = true
          }
        }
      },
      async draggableEnd () {
        try {
          let templateList = this.templateList.map((v, index) => ({ id: v.id, displaySequence: index }))
          await this.$http('system.genericSearch.template.update.sort', { templateList })
        } catch (e) {
          console.log(e)
        }
      },
      removeTemplate(item) {
        this.$emit('removeTemplate', item)
      },
      updateTemplate (item) {
        this.model.templateId = item.id
        this.model.templateName = item.name
        this.model.parentId = item.parentId
        this.model.folderFlag = item.folderFlag
        this.$emit('showNameDialog')
      },
      showMoreBtn (data) {
        return this.selectedItemId === data.id
      },
      nameClass (item) {
        return {
          'is-active': this.selectedItemId === item.id,
        }
      },
      // 添加文件夹
      addFolder () {
        this.model.folderFlag = 1
        this.model.templateId = ''
        this.model.templateName = ''
        this.model.parentId = 0
        this.$emit('showNameDialog')
      },
      // 更多事件派发
      handleMore (val, item) {
        this[val](item)
      },
      changeFolder () {
        if (!this.selectItem.id) {
          this.$emit('changeFolder')
        }
        this.selectItem = {
          name: ''
        }
      },
      moveFolder() {
        this.$emit('moveFolder')
      },
      allowDrop(draggingNode, dropNode, type) {
        const draggingData = draggingNode.data
        const dropData = dropNode.data
        if (draggingData.folderFlag === 1) {
          // 文件夹移动，文件夹不能移入
          if (type === 'inner' || dropData.invalidParentId) {
            return false
          }
          return true
        } else {
          // 文件移动
          if (dropData.folderFlag !== 1 && type === 'inner') {
            return false
          }
          return true
        }
      },
      async handleDragEnd (draggingNode, dropNode, dropType, ev) {
        try {
          let listData = []
          this.templateList.map((item, index) => {
            const listItem = {
              id: item.id,
              displaySequence: index + 1,
              folderFlag: item.folderFlag,
              parentId: 0
            }
            item.parentId = 0
            listData.push(listItem)
            if (item.templateList && item.templateList.length) {
              item.templateList.map((newItem, newIndex) => {
                const newListItem = {
                  id: newItem.id,
                  displaySequence: newIndex + 1,
                  parentId: item.id
                }
                newItem.parentId = item.id
                listData.push(newListItem)
              })
            }
          })
          await this.$http('system.genericSearch.template.update.sort', {
            templateList: listData
          })
        } catch (error) {
          console.log(error)
        }
      },
      nodeExpand (data) {
        this.defaultExpandedKeys.push(data.id)
        this.saveExpandedKeys()
      },
      nodeCollapse (data) {
        this.defaultExpandedKeys = this.defaultExpandedKeys.filter(id => id !== data.id)
        this.saveExpandedKeys()
      },
      saveExpandedKeys () {
        let res = localStorage.getItem(FILE_NAME)
        const tag = `${this.$route.meta.tag}?${this.module.module}`
        if (res) {
          try {
            res = JSON.parse(res)
            res[tag] = this.defaultExpandedKeys
            localStorage.setItem(FILE_NAME, JSON.stringify(res))
          } catch (e) {
          }
        } else {
          res = { [tag]: this.defaultExpandedKeys }
          localStorage.setItem(FILE_NAME, JSON.stringify(res))
        }
      },
      getExpandedKeys () {
        let res = localStorage.getItem(FILE_NAME)
        if (res) {
          try {
            let tag = `${this.$route.meta.tag}?${this.module.module}`
            res = JSON.parse(res)
            res = res[tag]
            if (res && Array.isArray(res)) {
              this.defaultExpandedKeys = res
            }
          } catch (e) {
          }
        }
      },
      // 打开移动到的弹窗
      moveTemplate(item) {
        if (this.$refs.folderMove) {
          this.folderItem = item
          this.$refs.folderMove.show = true
        }
      },
      checkAllChange (val) {
        const list = this.flattenList()
        const isCheckAll = list.some(item => !item._checked)

        list.forEach(v => v._checked = isCheckAll)
        this.checkedMap.value = isCheckAll
        this.checkedMap.indeterminate = false
      },
      checkChange (data) {
        const list = this.flattenList()
        const unChecked = list.some(item => !item._checked)
        const checked = list.some(item => item._checked)

        this.checkedMap.value = list.some(item => item._checked)
        this.checkedMap.indeterminate = checked ? unChecked : false
      },
      flattenList () {
        return this.templateList.reduce((prev, cur) => {
          prev.push(cur)
          if (Array.isArray(cur.templateList) && cur.templateList.length) {
            cur.templateList.forEach(item => prev.push(item))
          }
          return prev
        }, [])
      }
    }
  }
</script>
<style lang="scss">
.custom-filter-module {
  width: 232px;
  border: 1px solid #e9e8ed;
  border-radius: 4px;
  // margin-left: 6px;
  &_search {
    display: flex;
    align-items: center;
    padding-right: 10px;
    .module_search-icon {
      padding: 4px;
      line-height: 1;
      cursor: pointer;
      font-size: 14px;
      &:hover {
        color: var(--g-color-primary);
      }
    }
  }
  .el-tree-node__expand-icon {
    display: none;
  }
  .tpl-popper {
    padding: 6px;
    .el-input__inner {
      padding-left: 24px !important;
      padding-right: 6px !important;
      border-radius: 4px;
      color: #333333;
      border-color: #e9e8ed;
      background-color: #ffffff;
    }
    .el-input__prefix {
      top: 5px;
      padding-left: 4px;
      font-size: 14px;
      color: #b3b1b1;
    }
  }
  .tpl-list {
    overflow: auto;
    width: 232px;
    .tpl {
      width: 100%;
      height: 24px;
      display: flex;
      align-items: center;
      padding: 0 6px;
      &:hover {
        background-color: #f1f1f5;
      }
      &-name {
        display: flex;
        flex: 1;
        align-items: center;
      }
      .name {
        flex: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow-x: hidden;
        cursor: pointer;
        font-size: 12px;
        max-width: 170px;
        padding: 4px 0;
        margin-left: 4px;
      }
      .el-icon-edit {
        color: var(--g-color-primary);
        cursor: pointer;
      }
      .el-icon-delete {
        cursor: pointer;
      }
      .is-active {
        color: #ff9300;
        font-weight: 600;
      }
      .is-batch {
        max-width: 136px;
      }
    }
    &-icon {
      width: 12px;
      height: 12px;
    }
    .module_more {
      line-height: 1;
      margin-right: 4px;
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  .el-scrollbar {
    height: 380px;
  }
  .el-scrollbar__wrap {
    height: 100%;
    overflow: auto;
    margin-right: 0px !important;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }
  .el-scrollbar__bar.is-horizontal {
    display: none;
  }
}
.custom-filter-icon-size {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/custom-filter-module.vue